import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-withdraw-dialogue',
  templateUrl: './withdraw-dialogue.component.html',
  styleUrls: ['./withdraw-dialogue.component.scss']
})
export class WithdrawDialogueComponent implements OnInit {
  title:string = 'Confirm Withdrawal Request';
  query:string ='Are you sure you want to withdraw?';
  constructor(private dialogRef: MatDialogRef<WithdrawDialogueComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,) { }

  ngOnInit(): void {
    if(this.data?.title){
      this.title = this.data?.title
    }
    if(this.data?.query){
      this.query = this.data.query;
    }
  }

}
